import { render, staticRenderFns } from "./SponsoringCheckboxModal.vue?vue&type=template&id=6f25751a&scoped=true&"
import script from "./SponsoringCheckboxModal.vue?vue&type=script&lang=ts&"
export * from "./SponsoringCheckboxModal.vue?vue&type=script&lang=ts&"
import style0 from "./SponsoringCheckboxModal.vue?vue&type=style&index=0&id=6f25751a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25751a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f25751a')) {
      api.createRecord('6f25751a', component.options)
    } else {
      api.reload('6f25751a', component.options)
    }
    module.hot.accept("./SponsoringCheckboxModal.vue?vue&type=template&id=6f25751a&scoped=true&", function () {
      api.rerender('6f25751a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign/SponsoringCheckboxModal.vue"
export default component.exports